.link {
  border: 2px dashed var(--color-border-primary);
  border-radius: 6px;
  color: var(--color-text-muted);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: 2rem;
  margin: 0 0 1rem;
  padding: 2rem;
  text-align: center;
  width: 100%;
  background-color: transparent;
  &:hover {
    border: 2px solid var(--color-border-primary);
  }
}
